import html2canvas from 'html2canvas';

export const takeSnapshot = (elId?: string, isUrl?: boolean, isRawBlob?: boolean): Promise<string | FormData | Blob> =>
  new Promise((res) => {
    let el;
    if (elId) {
      const elSelector = document.querySelector(`#${elId}`);
      if (elSelector) {
        el = elSelector;
      } else {
        el = document.body;
      }
    } else {
      el = document.body;
    }
    // @ts-ignore
    html2canvas(el).then((canvas) => {
      canvas.toBlob((blob) => {
        if (!blob) return;
        if (isUrl) {
          const url = URL.createObjectURL(blob);
          res(url);
        } else if (isRawBlob) {
          res(blob);
        } else {
          const fd: FormData = new FormData();
          fd.append('image', blob, 'Confirmation Screenshoot');
          res(fd);
        }
      });
    });
  });
